/**
 * Check and normalise the value of precision (must be positive integer)
 */
function _checkPrecision(val, base) {
  val = Math.round(Math.abs(val));
  return isNaN(val) ? base : val;
}

export default _checkPrecision;



//////////////////
// WEBPACK FOOTER
// ./node_modules/accounting-js/lib/internal/checkPrecision.js
// module id = null
// module chunks = 